import { createAction, props } from "@ngrx/store";
import { CriterioDto, CriterioHijoDto, MetaDto } from "../../models";

// export const loadAction = createAction('[UnidadV22 Page] Event');

export const load = createAction(
    '[Unidad Page] Load',
    props<{ tipo: string }>()
);
export const loadUnidadMetas = createAction(
    '[Unidad Page] Load UnidadMetas',
    props<{ idUnidad: number }>()
);

export const updateMeta = createAction(
    '[Unidad Page] Update Meta',
    props<{ meta: MetaDto }>()
);

export const updateCriterio = createAction(
    '[Unidad Page] Update Criterio',
    props<{ criterio: CriterioDto, unidadMetaId: number }>()
);

export const updateCriterioHijo = createAction(
    '[Unidad Page] Update Criterio Hijo',
    props<{ criterio: CriterioHijoDto, unidadMetaId: number, criterioId: number }>()
);

export const selectUnidadMetaId = createAction(
    '[Unidad Page] Select Id UnidadMeta',
    props<{ id: number }>()
);